import {IntlKeyValuePair, IntlNamespaces} from "./types";

export const INTL_PRIVACY_TEXT: IntlKeyValuePair = {
    key: "privacyText",
    defaultValue:
        "I agree to Unibuddy’s <1>Privacy Policy</1>  and <3>Terms of Use</3>, and the Institution's <5>Privacy Policy</5>",
    intlValue:
        "I agree to Unibuddy’s <1>Privacy Policy</1>  and <3>Terms of Use</3>, and the Institution's <5>Privacy Policy</5>",
    namespace: IntlNamespaces.PRIVACY_TEXT,
};

export const INTL_UNIBUDDY_PRIVACY: IntlKeyValuePair = {
    key: "unibuddyPrivacy",
    defaultValue: "I agree to the <1>Privacy Policy</1> and <3>Terms of Use</3> of Unibuddy",
    intlValue: "I agree to the <1>Privacy Policy</1> and <3>Terms of Use</3> of Unibuddy",
    namespace: IntlNamespaces.PRIVACY_TEXT,
};

export const INTL_UNIVERSITY_PRIVACY: IntlKeyValuePair = {
    key: "universityPrivacy",
    defaultValue: "I agree to the <1>Privacy Policy</1> of {{universityName}}",
    intlValue: "I agree to the <1>Privacy Policy</1> of {{universityName}}",
    namespace: IntlNamespaces.PRIVACY_TEXT,
};

export const INTL_UPDATED_UNIBUDDY_POLICY: IntlKeyValuePair = {
    key: "updatedUnibuddyPolicy",
    defaultValue:
        "By signing up you agree to Unibuddy’s <1>Privacy Policy</1> and <3>Terms of Use</3>",
    intlValue:
        "By signing up you agree to Unibuddy’s <1>Privacy Policy</1> and <3>Terms of Use</3>",
    namespace: IntlNamespaces.PRIVACY_TEXT,
};

export const INTL_UPDATED_INSTITUTION_POLICY: IntlKeyValuePair = {
    key: "updatedInstitutionPolicy",
    defaultValue:
        "By completing your profile, you agree to the {{universityName}} <3>Privacy Policy</3>, which will outline if your data is shared with third parties.",
    intlValue:
        "By completing your profile, you agree to the {{universityName}} <3>Privacy Policy</3>, which will outline if your data is shared with third parties.",
    namespace: IntlNamespaces.PRIVACY_TEXT,
};

export const INTL_UPDATED_MARKETING_CONSENT: IntlKeyValuePair = {
    key: "updatedMarketingConsent",
    defaultValue:
        "By checking this box, you agree to receive marketing communication. You can unsubscribe at any time.",
    intlValue:
        "By checking this box, you agree to receive marketing communication. You can unsubscribe at any time.",
    namespace: IntlNamespaces.PRIVACY_TEXT,
};

export const INTL_UPDATED_INSTITUTION_POLICY_SHORT: IntlKeyValuePair = {
    key: "updatedInstitutionPolicyShort",
    defaultValue: "By continuing, you agree to the {{universityName}} <3>Privacy Policy</3>.",
    intlValue: "By continuing, you agree to the {{universityName}} <3>Privacy Policy</3>.",
    namespace: IntlNamespaces.PRIVACY_TEXT,
};
